import React from 'react';
import { EntityId } from "@reduxjs/toolkit";
import { useAppDispatch, useAppSelector } from "../../../../store/hooks";
import { destroyTemplate } from "../../../../actions/roblox/templatesActions";
import { useNavigate } from "react-router-dom";

import { ButtonDestroy, ButtonEdit } from "../../../../componets/Buttons";
import { setEditId, TemplateInterface } from "../../../../store/roblox/templatesSlice";
import { ColumnsType } from "antd/es/table";
import { message, Space } from "antd";

import Table from "../../../../componets/Table";
import Meta from "./_Meta";

const TYPES = { 0: 'Pants', 1: 'Shirt', 2: 'TShirt' };

interface ListTableInterface {
  className?: string;
}

const _ListTable = ({ className }: ListTableInterface) => {
  const navigate        = useNavigate();
  const dispatch        = useAppDispatch();
  const ids             = useAppSelector(state => state.roblox.templates.ids);
  const templates    = useAppSelector(state => state.roblox.templates.entities);
  const data            = ids ? ids.map(id => templates[id]) : [];

  function onClickEdit(id: EntityId) {
    dispatch(setEditId(id));
  }

  function onClickDestroy(id: EntityId) {
    handleDestroy(id).catch(console.error);
  }

  async function handleDestroy (id: any) {
    const resultAction = await dispatch(destroyTemplate(id));

    if (destroyTemplate.fulfilled.match(resultAction)) {
      message.success(`ItemID ${id} was successful deleted`);
      setTimeout(() => navigate(0), 1000);
    }

    if (destroyTemplate.rejected.match(resultAction)) {
      message.error(resultAction.error.message);
    }
  }

  const columns: ColumnsType<TemplateInterface> = [
    {
      key: 'template',
      title: 'Template',
      render: (_, template) => {
        return <Meta template={template} size='medium' showStats={true} />;
      },
      width: 185,
      ellipsis: true
    },

    {
      key: 'type',
      title: 'Type',
      render: (_, { type_id }) => {
        return (
          <div>
            {TYPES[type_id]}
          </div>
        );
      },
      width: 250
    },

    {
      key: 'action',
      title: 'Action',
      render: (_, { id}) => {
        return (
          <Space size="middle">
            <ButtonEdit key={'button-edit'} onClick={() => onClickEdit(id)} />
            <ButtonDestroy key='button-destroy' onClick={() => onClickDestroy(id)} />
          </Space>
        );
      },
      width: 150
    },
  ];

  return (
    <div className={className}>
      <Table
        rowKey='id'
        columns={columns}
        dataSource={data}
      />
    </div>
  )
}

export default _ListTable;
